module.exports = __webpack_public_path__ + "img/kh.71af87b1.svg";